import superagent from "superagent";
import { handleAuthError, parseError } from "../utils/apiErrors";

export const request = (method, url, body) => {
  return new Promise((resolve, reject) => {
    superagent[method](url, body).end((error, result) => {
      if (error) {
        handleAuthError(error, () => {
          reject(parseError(error));
        });
      } else if (result && result.body) {
        resolve(result.body);
      } else if (result && result.text) {
        resolve(JSON.parse(result.text));
      } else {
        reject(parseError(new Error("Empty response from server")));
      }
    });
  });
};
